<template>
    <!--弹窗-->
    <el-dialog
        width="640px"
        :title="info.asin + '评价趋势'"
        :visible.sync="visible"
        :before-close="handleClose"
    >
        <div class="dayBox">
            <div class="leftDay">
                <el-radio-group @change="changeDay" v-model="query.radioDay" size="mini">
                    <el-radio-button label="30"></el-radio-button>
                    <el-radio-button label="90"></el-radio-button>
                    <el-radio-button label="365"></el-radio-button>
                </el-radio-group>
            </div>
            <div class="rightDay">
                <div>查看过去
                    <el-input type="number" style="width: 100px" v-model="query.day"
                              @change="inputDayChange" size="mini"></el-input>
                    天记录
                </div>
            </div>
        </div>
        <div class="tabSwitch">
            <el-radio-group @change="viewCharts" v-model="query.switchItem" size="mini">
                <el-radio-button label="reviews">ratings|reviews</el-radio-button>
                <el-radio-button label="score">评分</el-radio-button>
            </el-radio-group>
        </div>
        <div class="tabSwitch" v-show="query.switchItem == 'reviews'">
            <el-radio-group @change="viewCharts" v-model="query.star" size="mini">
                <el-radio-button label="总"></el-radio-button>
                <el-radio-button label="1星"></el-radio-button>
                <el-radio-button label="2星"></el-radio-button>
                <el-radio-button label="3星"></el-radio-button>
                <el-radio-button label="4星"></el-radio-button>
                <el-radio-button label="5星"></el-radio-button>
            </el-radio-group>
        </div>

        <div id="asinChartDom" style="min-width:400px;height:400px"></div>


        <!--        <span slot="footer" class="dialog-footer">-->
        <!--            <el-button @click="handleClose">取 消</el-button>-->
        <!--            <el-button type="primary" @click="handleClose(true)" :loading="loading">确 定</el-button>-->
        <!--          </span>-->

    </el-dialog>
</template>
<script>
import * as api from '@/api/Product/Product'
import * as echarts from 'echarts'

export default {
    data() {
        return {
            loading: false,
            asinInfo: {},
            query: {
                day: 30,
                radioDay: 30,
                star: '总',
                switchItem: 'reviews',
            },
            list: [],
            myChart: null,
            timer: null,
            isshow: false
        }
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        info: {
            type: Object,
            default: {}
        }
    },
    watch: {
        info: {
            handler(val) {
                this.asinInfo = val
            },
            deep: true,
        },
        visible: {
            handler(val) {
                val && this.asinChangeTrend()
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        asinChangeTrend() {
            api.track_asin_index_change_trend({
                id: this.info.id,
                day: this.query.day
            }).then(res => {
                if (res.code === 0) {
                    this.$nextTick(() => {
                        this.list = res.data || []
                        this.viewCharts()
                    })
                }
            }).catch(res => {
                this.$message({
                    type: 'error',
                    message: res.message
                })
            })
        },
        inputDayChange() {
            this.debounce(() => this.asinChangeTrend(), 500)
        },
        debounce(fn, delay) {
            if (this.timer) {
                clearTimeout(this.timer)
            }
            this.timer = setTimeout(() => {
                fn.apply(this, arguments)
            }, delay ? delay : 500)
        },
        changeDay(val) {
            this.query.day = val
            this.debounce(() => this.asinChangeTrend(), 500)
        },
        // 关闭弹窗
        handleClose() {
            this.query = {
                day: 30,
                radioDay: 30,
                star: '总',
                switchItem: 'reviews',
            }
            this.$emit('close-callback', true)
        },
        viewCharts() {
            let serviceArr = []
            const data = this.list
            const starArr = []
            let minNum = 0
            let maxNum = 0
            if (data.length > 0) {
                if (this.query.switchItem == 'reviews') {
                    let ratingKey = ''
                    let reviewKey = ''
                    switch (this.query.star) {
                        case '1星':
                            ratingKey = 'rating_1'
                            reviewKey = 'review_1'
                            break
                        case '2星':
                            ratingKey = 'rating_2'
                            reviewKey = 'review_2'
                            break
                        case '3星':
                            ratingKey = 'rating_3'
                            reviewKey = 'review_3'
                            break
                        case '4星':
                            ratingKey = 'rating_4'
                            reviewKey = 'review_4'
                            break
                        case '5星':
                            ratingKey = 'rating_5'
                            reviewKey = 'review_5'
                            break
                        case '总':
                            ratingKey = 'rating_total'
                            reviewKey = 'review_total'
                            break
                    }

                    let keyArr = [ratingKey, reviewKey]

                    for (const item of keyArr) {
                        let obj = {
                            name: item.split('_')[0] || '',
                            data: [],
                            type: 'line',
                        }
                        for (const dataItem of data) {
                            obj.data.push([dataItem.date, dataItem[item]])
                        }
                        serviceArr.push(obj)
                    }
                } else {
                    let obj = {
                        name: '评分',
                        data: [],
                        type: 'line',
                    }
                    for (const dataItem of data) {
                        obj.data.push([dataItem.date, dataItem.score])
                        starArr.push(dataItem.score)
                    }
                    minNum = Math.min(...starArr)
                    maxNum = Math.max(...starArr)
                    serviceArr.push(obj)
                }
            }
            this.myChart = null
            this.myChart = echarts.init(document.getElementById('asinChartDom'))
            this.option = {
                xAxis: [
                    {
                        axisLine: {
                            lineStyle: {
                                color: '#000'
                            }
                        },
                        splitLine: {
                            show: true
                        },
                        type: 'time',
                        splitNumber: 16,
                        axisLabel: {
                            rotate: 45,
                            interval: 'auto',
                            showMaxLabel: true,
                            formatter: (params, index) =>//自动处理x轴的时间格式，兼容日均和小时2种格式，日均：几月几日，小时：几时
                            {
                                let date = new Date(params)
                                let str
                                if (date.getHours() == 0 || date.getMinutes() > 0 || date.getSeconds() > 0) {
                                    str = index === 0 ? '' : `${date.getMonth() + 1}月${date.getDate()}日`
                                }
                                return str
                            }
                        }
                    }
                ],
                tooltip: {
                    trigger: 'axis',
                    confine: true,
                    formatter: (params) => {
                        let time = ''
                        let timeStr = ''
                        let valueStr = ''
                        time = new Date(params[0].value[0])
                        timeStr = `${time.getMonth() + 1}月${time.getDate()}日`
                        params.map((item) => {
                            if (item.value) {
                                valueStr += `<div style="width:100%}">${item.marker} ${item.seriesName}:${
                                    item.value[1] === 'null' ? '-' : item.value[1]
                                }  <span style="margin-left: 10px">${item.value[2] ? item.value[2] : ''}</span></div>`
                            }
                        })
                        return `${timeStr}<br/><div style="display:flex;justify-content: flex-start;flex-wrap: wrap;width:200px">${valueStr}</div>`
                    }
                },
                yAxis: [
                    {
                        // min: 0,
                        // max: 300,
                        type: 'value',
                        minInterval: 1,
                        name: ``,
                        showMaxLabel: true,
                        axisLine: {
                            lineStyle: {
                                color: '#000'
                            }
                        },
                        axisTick: {
                            show: true
                        },
                        axisLabel: {
                            formatter: '{value}',
                            textStyle: {
                                fontSize: 14
                            }
                        }
                    }
                ],
                series: serviceArr
            }
            if (this.query.switchItem == 'score') {
                this.option.yAxis[0].min = minNum
                this.option.yAxis[0].max = maxNum
            } else {
                delete this.option.yAxis[0].min
                delete this.option.yAxis[0].max
            }

            // 绘制图表
            this.myChart.setOption(this.option, true)
        }

    }
}
</script>
<style type="text/scss" lang="scss">
.dayBox {
    display: flex;
    justify-content: space-between;
}

.tabSwitch {
    margin-top: 15px;
}
</style>

